import { Box, Stack, Typography } from '@mui/material';

import { TourSequence } from '@/domain/project-tour-ontour/entities/project-tour-ontour-sequence.entity';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { ScoreText } from '@/ui/components/score-text/ScoreText';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

import { ActionMenuForTourSequence } from './ActionMenuForTourSequence';

export function Co2OnTourDetailsSequencesItem({
  sequence,
  eventCount,
  co2,
  co2PerEvent,
  onClickOpen,
  onClickEdit,
  onClickDelete,
}: {
  sequence: TourSequence;
  eventCount: number;
  co2: number;
  co2PerEvent: number;
  onClickOpen: () => void;
  onClickEdit: () => void;
  onClickDelete: () => void;
}) {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: ColorsRaw.anthracite.Anthracite_4,
        borderRadius: 4,
        px: 2,
        py: 2,
      }}
    >
      <Stack sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        {/* left bloc : title + dates + travel distance */}
        <Stack sx={{ flexGrow: 1, gap: 1 }}>
          <Typography sx={{ fontSize: '1.25rem', fontWeight: 800 }}>
            {sequence.name}
          </Typography>
          <Stack sx={{ flexDirection: 'row', gap: 4 }}>
            <ScoreText
              value={eventCount?.toString() || '-'}
              text={translate('ProjectsTour.dates')}
            />
          </Stack>
        </Stack>
        {/* middle bloc : co2 emissions */}
        <Stack sx={{ flexDirection: 'row', gap: 0 }}>
          <Stack sx={{ width: '10rem', flexDirection: 'row' }}>
            <ScoreText
              value={`${co2.toString()} ${translate('Projects.teCO2')}`}
              text={translate('ProjectsTour.emited')}
              variant={'box'}
            />
          </Stack>
          <Stack sx={{ width: '10rem', flexDirection: 'row' }}>
            <ScoreText
              value={`${co2PerEvent.toString()} ${translate('Projects.teCO2')}`}
              text={translate('ProjectsTour.emited-by-date')}
              variant={'box'}
            />
          </Stack>
        </Stack>
        {/* right bloc : action buttons */}
        <Stack sx={{ flexDirection: 'row', gap: 2 }}>
          <FSPrimaryButton onClick={onClickOpen}>
            {translate('Common.visit-text-button')}
          </FSPrimaryButton>
          <ActionMenuForTourSequence
            onClickEdit={onClickEdit}
            onClickDelete={onClickDelete}
          />
        </Stack>
      </Stack>
    </Box>
  );
}
